import { render } from "./AsIconBase.vue?vue&type=template&id=14ebf126&ts=true"
import script from "./AsIconBase.vue?vue&type=script&lang=ts"
export * from "./AsIconBase.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__